export var SegmentFilters;
(function (SegmentFilters) {
    SegmentFilters["ALL"] = "ALL";
    SegmentFilters["CASH"] = "Cash";
    SegmentFilters["DERIVATIVE"] = "FNO";
    SegmentFilters["CURRENCY"] = "Currency";
    SegmentFilters["PAYIN"] = "Funds Brought In";
    SegmentFilters["PAYOUT"] = "Funds Moved Out";
})(SegmentFilters || (SegmentFilters = {}));
